/**
 * Licensed to the Apache Software Foundation (ASF) under one
 * or more contributor license agreements.  See the NOTICE file
 * distributed with this work for additional information
 * regarding copyright ownership.  The ASF licenses this file
 * to you under the Apache License, Version 2.0 (the
 * "License"); you may not use this file except in compliance
 * with the License.  You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */
import React from "react";
import AntdForm, { FormProps } from "antd/lib/form";
import { styled } from "@superset-ui/core";

const StyledForm = styled(AntdForm)`
    &.ant-form label {
        font-size: ${({ theme }) => theme.typography.sizes.s}px;
    }
    .ant-form-item {
        margin-bottom: ${({ theme }) => theme.gridUnit * 4}px;
    }
`;

export default function Form(props: FormProps) {
    return <StyledForm {...props} />;
}

export type { FormProps };
